import Lang from './languages';

import Dashboard from './views/Dashboard';

import UsersList from './views/Users/List';
import UsersProfile from './views/Users/Profile';
import EstablishmentsList from './views/Establishments/List';
import EstablishmentsView from './views/Establishments/View';
import ProductsList from './views/Products/List';
import ProductsView from './views/Products/View';
import ProductsEvents from './views/Products/Events';
import TicketsList from './views/Tickets/List';
import SettingsEditor from './views/Settings/Editor';

import Documentation from './components/Documentation';


module.exports = {
 getRoutes: function (language) {
  if (!language) return []
  return [
   { path: '/dashboard', exact: false, name: Lang[language].Dashboard.title, component: Dashboard },
   { path: '/users', exact: false, name: Lang[language].Users.titles.users, component: UsersList },
   { path: '/users/operators', exact: false, name: Lang[language].Users.titles.operators, component: UsersList },
   { path: '/users/providers', exact: false, name: Lang[language].Users.titles.providers, component: UsersList },
   { path: '/users/administrators', exact: false, name: Lang[language].Users.titles.administrators, component: UsersList },
   { path: '/profile', exact: true, name: Lang[language].Users.titles.profile, component: UsersProfile },
   { path: '/establishments', exact: true, name: Lang[language].Establishments.title, component: EstablishmentsList },
   { path: '/establishments', exact: false, name: Lang[language].Establishments.title, component: EstablishmentsView },
   { path: '/products', exact: true, name: Lang[language].Products.title, component: ProductsList },
   { path: '/products/events', exact: true, name: Lang[language].Events.title, component: ProductsEvents },
   { path: '/products', exact: false, name: Lang[language].Products.title, component: ProductsView },
   { path: '/tickets', exact: true, name: Lang[language].Tickets.title, component: TicketsList },
   { path: '/settings', exact: true, name: Lang[language].Settings.title, component: SettingsEditor },
   { path: '/documentation', exact: true, name: Lang[language].Documentation.title, component: Documentation },
  ]
 },

 getSidebar: function (language) {
  return [
   {
    name: Lang[language].Dashboard.title,
    url: '/dashboard',
    icon: 'fa fa-map-marker'
   },
   {
    name: Lang[language].Establishments.title,
    url: '/establishments',
    icon: 'fa fa-map-marker'
   },
   {
    name: Lang[language].Products.title,
    url: '/products',
    icon: 'fa fa-cubes',
    children: [
     {
      name: Lang[language].Events.title,
      url: '/products/events',
      icon: 'fa fa-calendar'
     }
    ]
   },
   {
    name: Lang[language].Tickets.title,
    url: '/tickets',
    icon: 'fa fa-ticket'
   }
  ]
 },
};


// WEBPACK FOOTER //
// ./websources/routes.js